module.exports = __webpack_public_path__ + "img/security.1b7ac018.svg";